export const STRIPE_PRODUCTS = {
  PREMIUM_ANNUAL: {
    priceId: 'price_1R6vGgLlRgfJQZpBiCuK2BDr',
    name: 'Premium - Paiement annuel',
    description: 'Recommandé pour les SARL et SAS',
    mode: 'subscription' as const,
  },
  ESSENTIAL_ANNUAL: {
    priceId: 'price_1R6vG1LlRgfJQZpB7mvBTpeG',
    name: 'Essentiel - Paiement annuel',
    description: 'Recommandé pour les auto-entrepreneurs',
    mode: 'subscription' as const,
  },
  PREMIUM: {
    priceId: 'price_1R6vFBLlRgfJQZpBa7thEHd9',
    name: 'Premium',
    description: 'Recommandé pour les SARL et SAS',
    mode: 'subscription' as const,
  },
  ESSENTIAL: {
    priceId: 'price_1R6v7mLlRgfJQZpBBl6apFlH',
    name: 'Essentiel',
    description: 'Recommandé pour les entreprises',
    mode: 'subscription' as const,
  },
} as const;

export type StripePlan = keyof typeof STRIPE_PRODUCTS;
export type StripeProduct = typeof STRIPE_PRODUCTS[StripePlan];